import { put, takeLatest } from 'redux-saga/effects';

import { ApiResult } from 'common/models';
import {
    CLEAR_PREVIEW_SUCCESS,
    FAILURE_HEADER,
    MASTER_DATA_LOAD_SUCCESS,
    SUCCESS_HEADER
} from 'common/config';
import { MessageType, Schema } from 'common/enums';
import { appStateActions } from 'common/redux/app-state';

import { DataEditorService } from './dataEditor.service';
import { dataEditorActions } from './dataEditor.slice';

const loadToMasterData = function* () {
    const payload = {
        sourceSchema: Schema.Preview,
        targetSchema: Schema.Master
    };
    const { hasErrors, errors, value }: ApiResult<any> = yield DataEditorService.loadToMasterData(
        payload
    );
    if (hasErrors) {
        yield put({
            type: dataEditorActions.loadToMasterDataFailed.type,
            payload: value && value.detail
        });
        yield put({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: FAILURE_HEADER,
                message: value && value.detail,
                type: MessageType.Error
            }
        });
    } else {
        yield put({
            type: dataEditorActions.loadToMasterDataSuccess.type,
            payload: MASTER_DATA_LOAD_SUCCESS
        });
        yield put({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: SUCCESS_HEADER,
                message: MASTER_DATA_LOAD_SUCCESS,
                type: MessageType.Success
            }
        });
    }
};

const loadToMasterDataWatch = function* () {
    yield takeLatest(dataEditorActions.loadToMasterData.type, loadToMasterData);
};

const clearPreview = function* () {
    const { hasErrors, errors, value }: ApiResult<any> = yield DataEditorService.clearPreview();
    if (hasErrors) {
        yield put({
            type: dataEditorActions.clearPreviewFailed.type,
            payload: value && value.detail
        });
        yield put({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: FAILURE_HEADER,
                message: value && value.detail,
                type: MessageType.Error
            }
        });
    } else {
        yield put({
            type: dataEditorActions.clearPreviewSuccess.type,
            payload: CLEAR_PREVIEW_SUCCESS
        });
        yield put({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: SUCCESS_HEADER,
                message: CLEAR_PREVIEW_SUCCESS,
                type: MessageType.Success
            }
        });
    }
};

const clearPreviewWatch = function* () {
    yield takeLatest(dataEditorActions.clearPreview.type, clearPreview);
};

export { loadToMasterDataWatch, clearPreviewWatch };
